/*-- import aliases -----------
'!/...' -> project root
'~/...' -> js folder root
-----------------------------*/

// Custom-element registration only — deliberately tiny, and loaded WITHOUT `defer` from the
// <head> in Base/Views/Shared/_Layout.cshtml.
//
// <blue-composition> / <blue-component> wrap most of the page. Until they are defined they
// are unknown elements; on upgrade, Element.#Create() re-parents their children into a
// slotted <span> and attaches a shadow root. When the definitions came in with the deferred
// index.js bundle that reflow landed after first paint and Chrome scored it as unexpected
// layout shift (0.295 of the 0.311 mobile CLS on PageSpeed). Defining them here means the
// upgrade happens while the parser is still building the DOM, so it costs nothing visually.
//
// Keep this file free of anything that needs the document to be ready, or that needs the
// polyfills bundle: both index.js and polyfills.js run later. See core/_component.js.
// Imported straight from ~/core/_define rather than the ~/core barrel so the bundle does not
// drag in Blue and the Initializer.
import defineElements from "~/core/_define";

defineElements();
